import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.56 15.56" width="1em" height="1em">
    <g data-name="Layer 2">
      <g data-name="Layer 4" stroke="fj-icons-primary-color">
        <rect
          x={0.28}
          y={0.28}
          width={15}
          height={15}
          rx={3}
          ry={3}
          strokeMiterlimit={10}
          fill="fj-icons-bg-color"
          strokeWidth={0.56}
        />
        <path
          strokeWidth={0.43}
          fill="none"
          strokeMiterlimit={10}
          d="M9.97 2.941l2.644 2.645-6.611 6.611-2.645-2.645z"
        />
        <path
          d="M11.551 1.901l2.122 2.122a.37.37 0 010 .523l-1.061 1.06h0L9.96 2.956h0l1.096-1.096a.37.37 0 01.524 0z"
          fill="fj-icons-primary-color"
          strokeWidth={0.43}
          strokeMiterlimit={10}
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="fj-icons-primary-color"
          strokeWidth={0.43}
          d="M1.78 13.78l4.1-1.46-2.64-2.63-1.46 4.09z"
        />
      </g>
    </g>
  </svg>
);

const PencilBordered = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default PencilBordered;
